import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import SeekChat from './seekChat/index.jsx';
import SeekInputBar from "./seekInput/index.jsx";
import RestrictionScreen from "./restrictionScreen/index.jsx";

import { fetchSeekAnswer, invalidateSeekSession, fetchSeekLimit } from "actions/seek.jsx";
import cx from "classnames";
import closeIcon from 'images/close-icon.svg';
import paperfliteLogo from 'images/logo-dark.png';
import newChatIcon from 'images/new-chat.svg';
import _ from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import styles from "./seek.module.scss";
import { trackAdoptionMetricsForNewChatClickedEvent, trackAdoptionMetricsForSeekViewClickedEvent, trackAdoptionMetricsForContentSearchedEvent } from "actions/adoption.jsx";
import SeekInputArea from "./seekInputArea/index.jsx";



export default function SeekView(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const seekEnabled = useSelector((state) => _.get(state, 'users.account.item.seekEnabled') || null);
  const profile = useSelector((state) => _.get(state, 'users.profile.item') || null);
  const session = useSelector((state) => _.get(state, 'seek.session.item'));
  const isLimitExceeded = useSelector((state) => _.get(state, 'seek.isLimitExceeded'));
  const loading = useSelector((state) => _.get(state, 'seek.session.loading'));

  const [state, setState] = useState({
    showChats: loading || _.get(session, "id") != null,
    renderToBottom: false,
    typing: false,
    question: "",
    disableSearchBar: false,
    newChat: false
  });

  useEffect(() => {
    dispatch(fetchSeekLimit());
  }, [])

  const handleScrollWhileTyping = () => {

    const element = document.getElementById("chatContainer");

    if (element) {
      var scrollHeight = element.scrollHeight - 100;
      element.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }

  }

  const getQueryInputPlaceholder = () => {
    
    if (!state.showChats) {
      return "What are you looking for?";
    }

    return props.querying || state.disableTyping || state.typing
      ? "Please wait, response is being generated..."
      : "Type your follow on question...";
  };

  const handleSubmit = (prompt) => {
    let question = prompt || state.question;
    let sessionId = _.get(session, "id");

    dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Seek", question, "", "", ""));
    
    if(!props.showSeek){
      props.setShowSeek(true);
      dispatch(trackAdoptionMetricsForSeekViewClickedEvent("Seek View Clicked"));
    }
    if (question) {
      dispatch(fetchSeekAnswer(sessionId, question));
      setState({
        ...state,
        showChats: true,
        question: "",
        renderToBottom: true,
        typing: true
      });
    }
  }

  const handleNewChat = () => {
    dispatch(invalidateSeekSession());
    dispatch(trackAdoptionMetricsForNewChatClickedEvent("New Chat Clicked"));
    setState({
      question: "",
      renderToBottom: true,
      newChat: true,
    });
  }

  return (
    <div className={cx(styles.seekContainer, {
      [styles.seekActive] : props.showSeek
    })}>
      {props.showSeek && 
      <p className={styles.headerContainer}>
        <div className={styles.headerWrapper} 
          onClick={() => {
            props.setShowSeek(false)
            setState({
              renderToBottom: false,
              question: "",
            })
            dispatch(invalidateSeekSession())
          }}>
            <div className={styles.header}>
              <i className="paperflite-left-arrow" /> 
              <span>seek</span>
            </div>
          <span className={styles.subHeader}>powered by Paperflite</span>
        </div>
        <div className={cx(styles.newChatWrapper, {
          [styles.disabledNewChat]: state.typing
        })}
        onClick={(e) => {
          e.preventDefault();
          handleNewChat();
          }}
        >
          <i className="paperflite-add"></i>
          <span className={styles.newChat}>New chat</span>
        </div>
      </p>
      }

      {(!isLimitExceeded && seekEnabled) &&
        <>
          <SeekInputArea
            isLimitExceeded={props.isLimitExceeded}
            className={cx(styles.questionBar, {
              [styles.renderToBottom]: state.renderToBottom,
              [styles.stayAtBottom]: state.renderToBottom && state.newChat, 
              [styles.adjustedStayAtBottom]: state.renderToBottom && state.showChats && !props.attachAssets,
            })}
            value={state.question}
            disabled={state.typing}
            placeholder={getQueryInputPlaceholder()}
            onChange={(value) => {
              setState({
                ...state,
                question: value,
                renderToBottom: state.renderToBottom,
                showChats: state.showChats
              });
            }}
            onPromptClick={(prompt) => {
              setState({
                ...state,
                question: prompt,
                renderToBottom: true,
                showChats: true
              })
              handleSubmit(prompt);
            }
            }
            onSubmit={handleSubmit}
            showChats={state.showChats}
          />
            
        {props.showSeek &&   <div
            className={cx(styles.newChatContainer, {
              [styles.showNewChat]: state.showChats,
            })}
          >
          </div>
      }
        </>
      }

      {state.showChats && props.showSeek && !isLimitExceeded && (
        <div
          className={cx(styles.sessionContainer, {
            [styles.limitExceeded]: isLimitExceeded,
          })}
          id="chatContainer"
        >
          <div className={styles.session}>
            {(_.get(session, 'chats') || []).map((chat, index) => {
              return (
                <SeekChat
                  handleScrollWhileTyping={() => {
                    handleScrollWhileTyping()
                  }}
                  handleEnableTyping={() => {
                    setState({
                      ...state,
                      typing: true
                    })
                  }}
                  handleDisableTyping={() => {
                    setState({
                      ...state,
                      typing: false
                    })
                  }}
                  key={index}
                  chat={chat}
                  attachAssets={_.get(props, "attachAssets")} />
              )
            })}
          </div>
        </div>
      )}
    </div>
  );
}